import { Component, Inject } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    template: `
        <nb-card>
            <nb-card-header>{{ title }}</nb-card-header>
            <nb-card-body>{{ message }}</nb-card-body>
            <nb-card-footer>
                <button nbButton status="primary" (click)="confirm()">Yes</button>
                <button nbButton status="basic" (click)="cancel()">No</button>
            </nb-card-footer>
        </nb-card>
    `,
})
export class ConfirmationSellerDialogComponent {
    title: string;
    message: string;
    constructor(
        public nbDialogRef: NbDialogRef<ConfirmationSellerDialogComponent>
    ) {}

    confirm() {
        this.nbDialogRef.close(true);
    }

    cancel() {
        this.nbDialogRef.close(false);
    }
}
